import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Workflow from "../components/Workflow";
import Benefits from "../components/Benefits";
import CTASection from "../components/CTASection";
import "./home.css";

const Home = () => (
  <main className="home">
    <Hero />
    <About />
    <Workflow />
    <Benefits />
    <CTASection />
  </main>
);

export default Home;
